import { Button } from '@mui/material';
import React from 'react';
import {
  BakeryDiningOutlined,
  CategoryOutlined,
  CoffeeOutlined,
  EggOutlined,
  IcecreamOutlined,
  Inventory2Outlined,
  LocalPizzaOutlined,
  OutdoorGrillOutlined,
  SpaOutlined,
} from '@mui/icons-material';
import { foodTypeNames } from '../../../models/foodTypes';
import { Colors } from '../../../assets/theme/Colors';

const renderIcon = (type) => {
  switch (type) {
    case foodTypeNames.beverages:
      return <CoffeeOutlined />;
    case foodTypeNames.bakedGoods:
      return <BakeryDiningOutlined />;
    case foodTypeNames.produce:
      return <SpaOutlined />;
    case foodTypeNames.dairy:
      return <IcecreamOutlined />;
    case foodTypeNames.eggs:
      return <EggOutlined />;
    case foodTypeNames.meat:
      return <OutdoorGrillOutlined />;
    case foodTypeNames.nonPerishable:
      return <Inventory2Outlined />;
    case foodTypeNames.nonFood:
      return <CategoryOutlined />;
    case foodTypeNames.preparedReadyToEat:
      return <LocalPizzaOutlined />;
    default:
      return null;
  }
};

const RouteStopCategory = ({ disabled, onCategoryClick, name = '', label = '', active = false }) => (
  <Button
    startIcon={renderIcon(name)}
    variant="outlined"
    size="small"
    disabled={disabled}
    onClick={onCategoryClick}
    sx={{
      borderRadius: '28px',
      py: 1,
      px: 2,
      mt: 1,
      mr: 1,
      textTransform: 'none',
      fontWeight: 700,
      color: active ? Colors.appBar.main : 'text.primary',
      borderColor: active ? Colors.appBar.main : 'text.disabled',
      bgcolor: active ? '#fdeae5' : 'default',
      '&:hover': {
        color: Colors.appBar.main,
        borderColor: Colors.appBar.main,
        bgcolor: active ? '#fdeae5' : '#fff',
        opacity: active ? 0.7 : 1,
      },
    }}
    data-testid={name}
  >
    {label}
  </Button>
);

export default RouteStopCategory;
